/**
 * SummaryApprovalHistory Component
 * Approval history display within the Contract Summary step
 */

import React from 'react';
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
} from '@mui/material';
import { format } from 'date-fns';

function SummaryApprovalHistory({ approvalHistory }) {
  return (
    <Paper sx={{ p: 3 }}>
      {approvalHistory.length === 0 ? (
        <Typography color="textSecondary" align="center">
          No contract history available
        </Typography>
      ) : (
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Date/Time</TableCell>
                <TableCell>Action</TableCell>
                <TableCell>User</TableCell>
                <TableCell>Status Change</TableCell>
                <TableCell>Comments</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {approvalHistory.map((entry) => (
                <TableRow key={entry.id}>
                  <TableCell>
                    {entry.timestamp ? format(new Date(entry.timestamp), 'dd MMM yyyy HH:mm') : '-'}
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={entry.description}
                      size="small"
                      color={
                        entry.action === 'approve'
                          ? 'success'
                          : ['reject', 'early_termination', 'matured_termination', 'cancel'].includes(entry.action)
                          ? 'error'
                          : entry.action === 'submit_for_approval'
                          ? 'warning'
                          : ['activate', 'extension', 'rollover'].includes(entry.action)
                          ? 'info'
                          : 'default'
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">{entry.user?.name || 'Unknown'}</Typography>
                    {entry.user?.email && (
                      <Typography variant="caption" color="textSecondary">
                        {entry.user.email}
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell>
                    {entry.old_status && entry.new_status ? (
                      <Typography variant="body2">
                        {entry.old_status} → {entry.new_status}
                      </Typography>
                    ) : entry.new_status ? (
                      <Typography variant="body2">{entry.new_status}</Typography>
                    ) : (
                      '-'
                    )}
                  </TableCell>
                  <TableCell>
                    {entry.comments ? (
                      <Typography variant="body2" sx={{ maxWidth: 200, wordWrap: 'break-word' }}>
                        {entry.comments}
                      </Typography>
                    ) : (
                      '-'
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
}

export default SummaryApprovalHistory;
